"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PreAlphaPlaceholder = void 0;
exports.PreAlphaPlaceholder = {
    AuthUserXid: 'prealpha:authuser',
    RedisServiceConnUid: 'prealpha0organization0service0conn',
    RedisServiceConnUid_FanggleKahbaRunner: 'prealpha0fanggle0kahba0runner0redis',
    AutomationProjectUid: 'prealpha0automation0project0uid',
};
//# sourceMappingURL=pre-alpha-placeholder.js.map